import { format, isValid } from "date-fns";
import { useCallback } from "react";
import { Calendar } from "../Calendar";
import { useIDatePickerContext } from "./context";

export const DatePickerContent = () => {
  const { value, maxDate, minDate, onChange, setOpen, setDisplayValue } =
    useIDatePickerContext();

  const formatValue = useCallback((date: Date | undefined): string => {
    if (!date || !isValid(date)) {
      return "";
    }
    return format(date, "MM/dd/yyyy");
  }, []);

  const handleCalendarSelect = useCallback(
    (date: Date) => {
      setDisplayValue(formatValue(date));
      onChange(date);
      setOpen(false);
    },
    [onChange, setOpen, setDisplayValue, formatValue],
  );

  return (
    <Calendar
      value={value}
      onChange={handleCalendarSelect}
      min={minDate}
      max={maxDate}
      isOpen={true}
      onOpenChange={setOpen}
      range={false}
    />
  );
};
